export default {
    field0: 'Area',
    field1: 'Makes',
    field2: 'Models',
    field3: 'Year',
    field4: 'Wheels',
    field5: 'Sensor activation',
    field6: 'OBD Diagnosis',
    field7: 'Relearn',
    field8: 'OEM sensor information',
    field9: 'Programming',
    field10: 'OEM Sensor P/N',
    field11: 'Number on OEM sensor',
    field12: 'Market'
}